export default function compareStrings(string1, string2, equal = true) {
  if ((!string1 || !string2) && !equal) return true;
  if (!string1 || !string2) return false;
  const isEqual = string1?.toLowerCase() === string2?.toLowerCase();

  if (equal) return isEqual;
  else return !isEqual;
}
